import React from 'react';
import { useTenant } from '../context/ThemeContext';

interface BrandLogoProps {
  size?: 'xl' | 'base';
  className?: string;
}

export const AppBrandLogo: React.FC<BrandLogoProps> = ({ size = 'xl', className = '' }) => {
  const { tenant } = useTenant();
  const sizeClass = size === 'base' ? 'text-base' : 'text-xl';
  const brandWord = tenant.id === 'mercedes' ? 'Mercedes' : 'Porsches';

  return (
    <div className={`flex items-baseline gap-2 ${className}`}>
      <span className={`text-primary font-display ${sizeClass} font-bold uppercase tracking-tight`}>Great</span>
      <span className={`text-mp-text font-display ${sizeClass} font-bold uppercase tracking-tight`}>Classic</span>
      <span className={`text-primary font-display ${sizeClass} font-bold uppercase tracking-tight`}>{brandWord}</span>
    </div>
  );
};